import { Filter, FilterFieldDescriptor } from '@totem/types/common';

export const buildFiltersFromDescriptors = <T>(
  input: T,
  descriptors: FilterFieldDescriptor[],
): Filter[] => {
  const filters: Filter[] = [];

  for (const desc of descriptors) {
    const val = input[desc.inputKey as keyof T];

    if (desc.isSingleValue) {
      if (typeof val === 'string' && val !== '') {
        const entry: Filter = { field: desc.backendField, values: [val] };
        if (desc.operator) {
          entry.operator = desc.operator;
        }
        filters.push(entry);
      }
    } else if (Array.isArray(val) && val.length > 0) {
      const entry: Filter = {
        field: desc.backendField,
        values: val as string[],
      };
      if (desc.operator) {
        entry.operator = desc.operator;
      }
      filters.push(entry);
    }
  }

  return filters;
};
